var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-top-item"},[_c('div',{staticClass:"home-item-count"},[_c('div',[_vm._v(_vm._s(_vm.label))]),_c('div',[_vm._v(_vm._s(_vm.itemCount))])]),_c('img',{attrs:{"src":_vm.imgPath}})])}
var staticRenderFns = []

export { render, staticRenderFns }